module.exports = __webpack_public_path__ + "static/img/coin.d9d8d06f.png";